<template>
  <v-dialog persistent v-model="loginDialog" max-width="600px">
    <template v-slot:activator="{ on }">
      <v-btn text class="black--text login" v-on="on" @click="loginClick()">
        <v-icon left>{{ loginTab.icon }}</v-icon>
        <span>{{ $t(loginTab.text) }}</span>
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="color3 background--text">
        {{ $t("login") }}
      </v-card-title>
      <form @submit.prevent="onLogin()">
        <v-card-text>
          <v-container>
            <v-layout row align-center justify-center>
              <v-flex xs10>
                <v-text-field
                  :label="$t('emailAddressReq')"
                  :rules="[rules.email]"
                  type="email"
                  v-model="loginDetails.email"
                ></v-text-field>
              </v-flex>
              <v-flex xs10>
                <v-text-field
                  :label="$t('passwordReq')"
                  :rules="[rules.required]"
                  type="password"
                  v-model="loginDetails.password"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="anchor--text"
            @click="loginDialog = false"
            >{{ $t("close") }}</v-btn
          >
          <v-btn
            class="color3 background--text"
            type="submit"
            :disabled="!formIsValid"
            :loading="loading"
            >{{ $t("login") }}</v-btn
          >
        </v-card-actions>
      </form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "Tabs",
  data() {
    return {
      loginDialog: false,
      loginDetails: {
        email: "",
        password: "",
      },
      rules: {
        required: (value) => !!value || "Required!",
        email: (value) =>
          (!!value && this.validEmail(value)) || "Invalid Email",
      },
    };
  },
  computed: {
    ...mapGetters(["loggedIn", "loginTab", "loading", "loginSuccessMessage", "loginErrorMessage"]),
    formIsValid() {
      return (
        this.validEmail(this.loginDetails.email) &&
        this.loginDetails.password !== ""
      );
    }
  },
  methods: {
    ...mapActions(["login"]),
    onLogin() {
      this.login(this.loginDetails);
      this.loginDialog = false;
      this.email = "";
      this.password = "";
      if(this.$router.currentRoute.name !== "home") {
        this.$router.push("/");
      }
    },
    validEmail: function (email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    loginClick() {
      this.logEvent("button_click", {
        name: "login"
      })
    }
  }
};
</script>

<style scoped>
.login {
    font-size: 1em !important;
}
</style>
